import React, { useEffect, useRef } from "react";
import styles from "../components/comp_css/chapter_58.module.css";
import { Link } from "@mui/material";
import { useRouter } from "next/router";
import Common_html from "./Common_html";
import BlockData from "../../../central-doctraine-json/chapter67.json";
import Head from "next/head";
export default function Chapter_67() {

  const router = useRouter()
  const location = useRouter();
  const { pathname } = location;

  // const corosalref = useRef()

  // useEffect(() => {
  //     if (corosalref.current) {
  //         corosalref.current.scrollIntoView({
  //             behavior: "smooth",
  //             block: "nearest",
  //             inline: "start"
  //         })
  //     }
  //     console.log("CurrentImageComponent", corosalref.current);
  // }, [corosalref.current])
  return (
    <>

      <Head>
        <title>Central Doctrine | School of Our Divine Infinite Being</title>
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1.0"
        ></meta>
        <meta
          name="keywords"
          content="Central Doctrine explores divine infinite being, spiritual awakening, universal truth, and conscious self-realization through wisdom."
        ></meta>
        <meta
          property="og:title"
          content="Science and Spirituality: A Forgotten Harmony in Human Understanding"
        ></meta>
        <meta property="og:type" content="website"></meta>
        <meta
          property="og:image"
          content="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/og_img/central_doctrinel_og_img.webp"
        ></meta>
        <meta
          property="og:image:alt"
          content="Illustration of a radiant, ethereal figure surrounded by a golden aura, symbolizing the Divine Infinite Being. The figure is positioned centrally, emanating light and energy, with abstract patterns representing spiritual interconnectedness and universal truth."
        ></meta>
        <meta
          property="og:description"
          content="The history of science reveals a deeper harmony between reason and spirituality. From Newton and Kepler to Pauli and Schrödinger, great minds sought both empirical truth and spiritual meaning. Modern narratives often overlook this connection, favoring atheism over integration. Re-examining their legacy reveals a richer, more balanced view of reality and human purpose."
        ></meta>

        <meta property="og:image:width" content="1200"></meta>
        <meta property="og:image:height" content="627"></meta>
        <meta
          property="og:url"
          content="https://www.divineinfinitebeing.com/central-doctrine?chapter=67"
        ></meta>

        <meta name="twitter:card" content="summary_large_image"></meta>
        <meta
          property="twitter:image"
          content="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/og_img/central_doctrinel_og_img.webp"
        ></meta>
        <meta
          property="twitter:image:alt"
          content="Illustration of a radiant, ethereal figure surrounded by a golden aura, symbolizing the Divine Infinite Being. The figure is positioned centrally, emanating light and energy, with abstract patterns representing spiritual interconnectedness and universal truth."
        ></meta>
        <meta
          name="twitter:url"
          content="https://www.divineinfinitebeing.com/central-doctrine?chapter=67"
        ></meta>
        <meta
          name="twitter:title"
          content="Science and Spirituality: A Forgotten Harmony in Human Understanding"
        ></meta>
        <meta
          name="twitter:description"
          content="At the School of Our Divine Infinite Being, the core teaching blends mystical insight with practical guidance for today’s world. Discover how its philosophy fosters inner transformation, connection to universal consciousness, and a life aligned with spiritual truth. This doctrine speaks to both the heart and mind, inspiring seekers on their journey."
        ></meta>
        <link rel="canonical" href="https://www.divineinfinitebeing.com/central-doctrine?chapter=67" />
      </Head>
      <Common_html BlockData={BlockData} />
    </>
  );
}
